import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ORIGIN = "https://bookandsmiles.com";

const setLink = (rel, hreflang, href, key) => {
  const selector = hreflang
    ? `link[rel="${rel}"][hreflang="${hreflang}"]`
    : `link[rel="${rel}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("data-seo", key);
  el.setAttribute("href", href);
};

// Single SPA-level effect: page_view tracking, canonical + hreflang per route.
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // GA4 page_view on every route change
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }

    // Per-route canonical + hreflang
    const path = location.pathname;
    const canonical = `${ORIGIN}${path}`;
    setLink("canonical", null, canonical, "canonical-spa");
    setLink("alternate", "en", `${canonical}?lang=en`, "hreflang-en-spa");
    setLink("alternate", "fr", `${canonical}?lang=fr`, "hreflang-fr-spa");
    ["en-US", "en-CA", "en-GB", "en-ZA", "en-NG", "en-NA", "en-IN", "en-AU"].forEach((h) =>
      setLink("alternate", h, `${canonical}?lang=en`, `hreflang-${h}-spa`)
    );
    ["fr-FR", "fr-CA", "fr-BE", "fr-CH"].forEach((h) => setLink("alternate", h, `${canonical}?lang=fr`, `hreflang-${h}-spa`));
    setLink("alternate", "x-default", canonical, "hreflang-x-spa");
  }, [location.pathname, location.search]);

  // Global delegation: any <a href="https://wa.me/..."> click → GA4 event.
  useEffect(() => {
    const handler = (e) => {
      const a = e.target && e.target.closest && e.target.closest('a[href*="wa.me/"]');
      if (!a || a.hasAttribute("data-no-wa-track")) return;
      if (typeof window.gtag !== "function") return;
      window.gtag("event", "whatsapp_click", {
        link_url: a.getAttribute("href"),
        link_text: (a.textContent || "").trim().slice(0, 80),
        page_path: window.location.pathname,
        data_testid: a.getAttribute("data-testid") || null,
      });
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);
};
